import styled from 'styled-components';

export const Label = styled.p`
  color: #a3a5a8;
  font-size: 12px;
  line-height: 20px;
  margin-bottom: 8px;
  margin-top: 0;
`;

export const Value = styled.p`
  color: #525356;
  font-size: 12px;
  line-height: 20px;
  margin: 0;
`;
